import React from 'react';
import { UrlService } from '../../../../../core/services/UrlService';
import { config } from '../../data/config';

import './hero.scss';

const GoldenEyeCareHero = ({ }) => {
    return (
        <>
            <div className="hero" style={config.images.home.heroBackgroundStyle}>
                <img className="img top-right-leaf" src={config.images.home.topRightLeaf} />
                <img className="img top-left-leaf" src={config.images.home.topLeftLeaf} />
                <img className="img family" src={config.images.home.family} />
                <img className="img title-text" src={config.images.home.titleText} />
            </div>
            <div className="hero-mobile">
                <img className="img mobile-banner" src={config.images.home.mobileBanner} />
            </div>
        </>
    );
};

export default GoldenEyeCareHero;
